module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContent',
        query: {
          order: _vm.order
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.merchandises), function(me) {
    return _c('div', {
      staticClass: "list-block",
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "15px"
      }
    }, [_c('ul', [_c('li', [_c('div', {
      staticClass: "item-content"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title label"
    }, [_vm._v("单价")]), _vm._v(" "), _c('div', {
      staticClass: "item-input"
    }, [_c('span', [_vm._v(_vm._s(me.unitPrice))])])])])]), _vm._v(" "), _vm._m(2, true)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('router-link', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("返回首页")])], 1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("商品详细信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-comment"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-comment"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("最小价格")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('span', [_vm._v("最小")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffe83e9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Order/Detail/OrderContentDetail.vue
// module id = 1747
// module chunks = 8